import React from "react";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
const TAX_RATE = 0.07;
const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    table: {
      minWidth: 700,
    },
  });

interface Props extends WithStyles<typeof styles> {
  activities: any;
}

const CustomTableCell = withStyles((theme) => ({
  root: {
    width: "calc(100vw/6)",
    display: "table-cell",
  },
}))(TableCell);

interface Row {
  desc: string;
  qty: number;
  unit: number;
  price: number;
}
class ActivitiesTableComponent extends React.Component<Props> {
  state = {
    columns: new Array<any>(),
    data: new Array<any>(),
    rows: [],
    invoiceSubtotal: 0,
    invoiceTaxes: 0,
    invoiceTotal: 0,
  };
  componentDidMount = () => {
    const rows = [
      this.createRow("Paperclips (Box)", 100, 1.15),
      this.createRow("Paper (Case)", 10, 45.99),
      this.createRow("Waste Basket", 2, 17.99),
    ];
    const invoiceSubtotal = this.subtotal(rows);
    const invoiceTaxes = TAX_RATE * invoiceSubtotal;
    const invoiceTotal = invoiceTaxes + invoiceSubtotal;
    this.setState({
      rows: rows,
      invoiceSubtotal: invoiceSubtotal,
      invoiceTaxes: invoiceTaxes,
      invoiceTotal: invoiceTotal,
    });
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {};

  ccyFormat = (num: number) => {
    return `${num.toFixed(2)}`;
  };

  priceRow = (qty: number, unit: number) => {
    return qty * unit;
  };

  createRow = (desc: string, qty: number, unit: number) => {
    const price = this.priceRow(qty, unit);
    return { desc, qty, unit, price };
  };

  subtotal = (items: Row[]) => {
    return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
  };

  getTableHead = (timeLines: any) => {
    if (!timeLines) {
      return;
    }
    let data = new Array<any>();
    let numPage = timeLines.length / 6;
    let start = 0;
    for (var i = 0; i < numPage; i++) {
      let resultData = new Array<any>();
      for (var j = start; j < timeLines.length; j++) {
        if (resultData.length < 6) {
          resultData.push(timeLines[j]);
          start = j + 1;
        }
      }
      data.push({ items: resultData });
    }
    return data;
  };

  render() {
    const { activities, classes } = this.props;
    let timeLineData = this.getTableHead(activities.timelines);
    return (
      <TableContainer component={Paper} style={{ padding: 10 }}>
        <Table className={classes.table} aria-label="spanning table">
          {timeLineData &&
            timeLineData.map((activityItem: any, index: any) => (
              // <div key={`timeline-data-${index}`}>
              <React.Fragment key={`timeline-data-${index}`}>
                <TableHead>
                  <TableRow>
                    {activityItem.items.map((activityItem: any, index: any) => (
                      <CustomTableCell
                        key={`activity-item-${index}`}
                        style={{
                          textAlign: "center",
                          border: "0px solid #69899F",
                        }}
                      >
                        {activityItem.time}
                      </CustomTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {activityItem.items.map((mItem: any, index: any) => (
                      <TableCell
                        key={`activity-item-table-${index}`}
                        style={{
                          justifyContent: "center",
                          padding: 0,
                          alignItems: "center",
                          border: "0px solid #69899F",
                        }}
                      >
                        {mItem.events.map((eventItem: any, index: any) => {
                          if (eventItem.activity && eventItem.activity.symbol) {
                            return (
                              <TableCell
                                key={`event-item-${index}`}
                                style={{
                                  textAlign: "center",
                                  justifyContent: "center",
                                  border: "1px solid #69899F",
                                  alignItems: "center",
                                }}
                              >
                                {eventItem.activity.symbol}
                              </TableCell>
                            );
                          } else {
                            return (
                              <TableCell
                                key={`event-item-${index}`}
                                style={{
                                  textAlign: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  border: "1px solid #69899F",
                                  alignItems: "center",
                                }}
                              >
                                L
                              </TableCell>
                            );
                          }
                        })}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </React.Fragment>
              // </div>
            ))}
        </Table>
        {/* {timeLineData &&
            timeLineData.map((tableItem: any, index: any) => {
              return (
                <TableBody>
                  <TableRow>
                    <TableCell
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {tableItem.items.map((activityItem: any, mIndex: any) =>
                        activityItem.events.map(
                          (eventItem: any, index: any) => (
                            <TableCell
                              style={{
                                width: "30%",
                                textAlign: "center",
                                border: "1px solid #69899F",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              12
                            </TableCell>
                          )
                        )
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              );
            })} */}
      </TableContainer>
    );
  }
}
export default withStyles(styles)(ActivitiesTableComponent);
